// extracted by mini-css-extract-plugin
export default {"blog":"styles_blog__8ir7h","blog__link":"styles_blog__link__8pEZF","item":"styles_item__oYKu1","item__in":"styles_item__in__Wn-ie"};